import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DealerInformation } from '../../shared/models/dealer-information.model';
import {
  DealerSettings,
  DealerWifi,
  OutletSettings,
  PdiMarketSettings,
  PdiSettingsField,
} from '../../shared/models/dealer-settings.model';

@Injectable()
export class DealerService {
  private readonly httpClient = inject(HttpClient);

  private readonly apiUrl = '/api/dealership/dealer';
  private readonly wifiUrl = '/settings/wifi/';

  getDealers(): Observable<DealerInformation[]> {
    return this.httpClient.get<DealerInformation[]>(this.apiUrl);
  }

  getBatteryCareDealers(): Observable<DealerInformation[]> {
    return this.httpClient.get<DealerInformation[]>(this.apiUrl + '/battery-care');
  }

  getDealerSettings(buno: string, marketCode: string): Observable<DealerSettings> {
    return this.httpClient.get<DealerSettings>(this.apiUrl + `/${buno}/settings/${marketCode}`);
  }

  getWifi(buno: string, id: number): Observable<DealerWifi> {
    return this.httpClient.get<DealerWifi>(this.apiUrl + `/${buno}` + this.wifiUrl + id);
  }

  createWifi(buno: string, wifi: DealerWifi): Observable<DealerWifi> {
    return this.httpClient.post<DealerWifi>(this.apiUrl + `/${buno}` + this.wifiUrl, wifi);
  }

  updateWifi(buno: string, wifi: DealerWifi): Observable<DealerWifi> {
    return this.httpClient.put<DealerWifi>(this.apiUrl + `/${buno}` + this.wifiUrl + wifi.id, wifi);
  }

  updateDefaultWifi(buno: string, wifi: DealerWifi): Observable<void> {
    return this.httpClient.put<void>(this.apiUrl + `/${buno}` + this.wifiUrl + 'default', wifi);
  }

  deleteWifi(buno: string, wifi: DealerWifi): Observable<void> {
    return this.httpClient.delete<void>(this.apiUrl + `/${buno}` + this.wifiUrl + wifi.id);
  }

  updateOutletSettings(buno: string, outletSettings: OutletSettings): Observable<OutletSettings> {
    return this.httpClient.put<OutletSettings>(this.apiUrl + `/${buno}/settings/outlet`, outletSettings);
  }

  updatePdiSettings(dealerId: string, pdiSettings: PdiSettingsField): Observable<PdiSettingsField> {
    return this.httpClient.put<PdiSettingsField>(this.apiUrl + `/${dealerId}/settings/pdi`, pdiSettings);
  }

  createPDIMarketSettings(
    dealerBpId: string,
    marketCode: string,
    pdiMarketSettings: PdiMarketSettings[]
  ): Observable<PdiMarketSettings> {
    return this.httpClient.post<PdiMarketSettings>(
      this.apiUrl + `/${dealerBpId}/settings/${marketCode}`,
      pdiMarketSettings
    );
  }

  updatePDIMarketSettings(
    dealerBpId: string,
    marketCode: string,
    pdiMarketSettings: PdiMarketSettings[]
  ): Observable<PdiMarketSettings> {
    return this.httpClient.put<PdiMarketSettings>(
      this.apiUrl + `/${dealerBpId}/settings/${marketCode}`,
      pdiMarketSettings
    );
  }
}
